import styled, { css } from 'styled-components';
import { Stack } from 'src/components';
import { headerDesktopFullHeight, headerDesktopMinWidth } from 'src/containers';

export const Content = styled(Stack)(
  ({ theme }) => css`
    margin: auto;
    width: 100%;
    max-width: ${theme.sz.md};
    margin-bottom: ${theme.sz.s12};
  `,
);

export const SearchWrapper = styled.div(
  ({ theme }) => css`
    position: sticky;
    top: ${theme.sz.s18};
    display: grid;
    background: ${theme.co.neutral99};
    padding-top: ${theme.sz.s10};
    gap: ${theme.sz.s10};
    z-index: ${theme.zi.z1};

    @media (max-width: ${theme.sz.md}) {
      gap: ${theme.sz.s4};
      padding-top: ${theme.sz.s4};
    }

    @media (min-width: ${theme.sz.md}) {
      top: ${theme.sz.s18};
    }

    @media (min-width: ${headerDesktopMinWidth}) {
      top: ${headerDesktopFullHeight};
    }

    input[type='search'] {
      -webkit-appearance: none;
    }
  `,
);

export const NoResults = styled.div(
  ({ theme }) => css`
    text-align: center;
    margin-top: 0;
    color: ${theme.co.secondary60};
    padding: ${theme.sz.s10} 0;
  `,
);

export const NoResultsTitle = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xs};
    padding-bottom: ${theme.sz.s2};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.heading.mobile.xs};
    }
  `,
);

export const NoResultsDescription = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.m};
    }
  `,
);
